import { Flex } from "@chakra-ui/react";
import useSmallScreen from "../../../components/useSmallScreen";
import LiveStreamCard from "./LiveStreamCard";

function LiveStreamList({post}) {
  const [smallScreen] = useSmallScreen();
  console.log('post',post)
  let liveStreamList = [
    1
  ];
  return (
    <Flex
      flexDirection={"row"}
      alignItems="center"
      flexWrap={"wrap"}
      gap="20px"
      justifyContent={["unset", "flex-start"]}
      w={smallScreen ? "fit-content" : "unset"}
    >
      {post?.map((data) => {
        return <LiveStreamCard  data={data}/>;
      })}
    </Flex>
  );
}

export default LiveStreamList;
